import { Avatar, Container, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { CheckCircle } from "@material-ui/icons";
import { Events } from "app-interfaces";
import React from "react";
import { useTranslation } from "react-i18next";

import ListClientsModal from "../../Modals/ListClientsModal";
import Icons from "../../Utilities/Icons";

const useStyles = makeStyles((theme) => ({
  "session-clients": {
    backgroundColor: "#5A9AE5",
    padding: 15,
    borderBottom: "1px solid rgba(255,255,255,0.17)",
    "& .client-profile": {
      "& .MuiAvatar-root": {
        float: "left",
        height: 34,
        width: 34,
        marginTop: -5,
        marginRight: 15,
      },
      "& .client-list-number": {
        cursor: "pointer",
        display: "block",
        position: "absolute",
        top: -5,
        left: 0,
        height: 34,
        width: 34,
        fontSize: theme.spacing(2),
        fontWeight: "bold",
        color: "#ffffff",
        borderRadius: "50%",
        padding: "6px 8px",
        backgroundColor: "#33333394",
      },
      "& .MuiTypography-subtitle1": {
        display: "block",
        width: "50%",
        fontSize: theme.spacing(2),
        fontWeight: 500,
        color: "#ffffff",
        marginLeft: 15,
      },
    },
    "& .session-status": {
      float: "right",
      marginTop: -25,
      fontSize: theme.spacing(2),
      fontWeight: 500,
      color: "#ffffff",
      "& svg": {
        marginRight: 5,
        height: theme.spacing(2),
        width: theme.spacing(2),
        fill: "var(--text-heading)",
      },
      "&.completed": {
        "& svg": {
          fill: "#ffffff",
        },
      },
    },
  },
}));

interface SessionClientsProps {
  session: Events.SessionResponse;
}

const SessionClients: React.FC<SessionClientsProps> = ({ session }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { ic_user } = Icons;
  const [isClientsListModalOpen, setIsShowClientsModalOpen] = React.useState(false);

  return (
    <>
      <Container id="session-clients" className={classes["session-clients"]}>
        <div
          className="client-profile"
          style={{ textTransform: "capitalize", position: "relative" }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          <Avatar
            alt="profile"
            src={session.customer[0].photo ? session.customer[0].photo.small : ic_user}
          />
          {session.customer.length > 1 && (
            <span className="client-list-number" onClick={() => setIsShowClientsModalOpen(true)}>
              +{session.customer.length - 1}
            </span>
          )}
          <Typography variant="subtitle1" component="span" noWrap>
            {session.customer[0].first_name} {session.customer[0].last_name}
          </Typography>
        </div>
        {session.state === "COMPLETED" && (
          <span
            className={
              session.state === "COMPLETED" ? "session-status completed" : "session-status"
            }
          >
            <CheckCircle />
            {session.state === "COMPLETED" ? t("Completed") : t("Upcoming")}
          </span>
        )}
      </Container>

      <ListClientsModal
        show={isClientsListModalOpen}
        onHide={() => setIsShowClientsModalOpen(false)}
        clientsList={session.customer}
      />
    </>
  );
};

export default SessionClients;
